// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2r25F","title":"AfterBackImages_title__1pbDO","images":"AfterBackImages_images__2UzXo"};